const savePartner = (context, payload) => {
  context.commit("SET_PARTNER", payload);
};

const saveQR = (context, payload) => {
  context.commit("SET_QR_CODE", payload);
};

const saveKeyBoard = (context, payload) => {
  context.commit("SET_KEY_BOARD", payload);
};

const setPartnerMovingBoxes = (context, payload) => {
  context.commit("SET_PARTNER_MOVING_BOXES", payload);
};

const removePartner = context => {
  context.commit("REMOVE_PARTNER");
};
const removeQR = context => {
  context.commit("REMOVE_QR_CODE");
};
const removeMoving = context => {
  context.commit("REMOVE_MOVING");
};

export default {
  savePartner,
  saveQR,
  saveKeyBoard,
  setPartnerMovingBoxes,
  removePartner,
  removeQR,
  removeMoving
};
